var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0029 10.702C24.1532 10.702 22.3792 11.4368 21.0712 12.7448C19.7632 14.0528 19.0284 15.8268 19.0284 17.6765C19.0284 19.5263 19.7632 21.3003 21.0712 22.6083C22.3792 23.9162 24.1532 24.6511 26.0029 24.6511C27.8527 24.6511 29.6267 23.9162 30.9347 22.6083C32.2426 21.3003 32.9774 19.5263 32.9774 17.6765C32.9774 15.8268 32.2426 14.0528 30.9347 12.7448C29.6267 11.4368 27.8527 10.702 26.0029 10.702ZM26.0029 29.3007C22.92 29.3007 19.9633 28.076 17.7834 25.8961C15.6034 23.7161 14.3787 20.7595 14.3787 17.6765C14.3787 14.5936 15.6034 11.6369 17.7834 9.45698C19.9633 7.27702 22.92 6.05233 26.0029 6.05233C29.0859 6.05233 32.0425 7.27702 34.2225 9.45698C36.4024 11.6369 37.6271 14.5936 37.6271 17.6765C37.6271 20.7595 36.4024 23.7161 34.2225 25.8961C32.0425 28.076 29.0859 29.3007 26.0029 29.3007ZM26.0029 0.240234C14.7042 0.240234 4.5679 7.21476 0.429688 17.6765C5.98606 31.8116 21.9345 38.7396 36.0695 33.1832C43.1602 30.3934 48.7864 24.7905 51.5762 17.6765C47.438 7.21476 37.3017 0.240234 26.0029 0.240234Z",
    fill: "#143D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.153291288f8650e91c7fa850b528ef42.svg";
export { ForwardRef as ReactComponent };